import { Component } from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationStart,
  Router,
} from "@angular/router";
import { AddClientWizardComponent } from '../../../../../add-client-wizard/add-client-wizard.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { DashboardStore } from '../../../../dashboard.store';

@Component({
standalone: true,
  selector: 'app-invite-clients',
  templateUrl: './invite-clients.component.html',
  styleUrls: ['./invite-clients.component.scss']
})
export class InviteClientsComponent {

  constructor(
    public router: Router,
    public BsModalRef: BsModalRef,
    public modalService: BsModalService,
    public dashboardStore: DashboardStore,
  ) {}

  public bsModalRef: BsModalRef;

  public openAddClientModal(company) {
    let modal: any = AddClientWizardComponent;

    this.BsModalRef = this.modalService.show(modal, {
      ignoreBackdropClick: true,
    });

    if (company != null) {
      this.bsModalRef.content.invited_to = company.id;
      this.bsModalRef.content.name = company.name;
      this.bsModalRef.content.ngOnChanges({});
    }
  }
}
